import React from 'react';
import AuthService from '../../services/auth.service';

// Define types for props
interface AuthGuardProps {
    permission?: string;
    children: React.ReactNode;
}

export const AuthGuard = (props: AuthGuardProps) => {
  const isAuthorized = !props.permission || AuthService.hasPermission(props.permission);

  return isAuthorized ? (
    <>
      {props.children}
    </>
  ) : null;
};